/**
 * Locale Constants
 * 
 * This file is auto-generated by scripts/fetch-language.ts
 * 
 * @see scripts/fetch-language.ts
 * 
 * DO NOT EDIT MANUALLY - Changes will be overwritten on next build
 */

export interface LanguageDetail {
  countryName: string | null; // Country name (extracted from Contentstack)
  nativeName: string; // Language name in its native script (extracted from Contentstack)
  isoCode: string; // ISO 639-1 language code (e.g., "en", "fr")
  langCode: string; // Language code (e.g., "en", "fr", "en-us", "tr-tr")
}

// Available locales in the Contentstack stack
export const SUPPORTED_LOCALES = [
  "en-us",
  "es"
] as const;

// Default locale for the application
export const DEFAULT_LOCALE = 'en-us' as const;

// TypeScript type for supported locales
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/**
 * Detailed language information
 * Includes country code, native name, and ISO language code
 */

export const LANGUAGE_DETAILS: LanguageDetail[] = [
  {
    "countryName": "United States",
    "nativeName": "English",
    "isoCode": "en",
    "langCode": "en-us"
  },
  {
    "countryName": null,
    "nativeName": "Spanish",
    "isoCode": "es",
    "langCode": "es"
  }
];

/**
 * Languages that should not appear in URL paths
 * Typically includes the default language to keep URLs clean
 */
export const LANGUAGES_WITHOUT_URL_PREFIX = [DEFAULT_LOCALE as string];
